import React, { useState, useEffect, useCallback } from "react";
import { Field, useFormik } from "formik";
import { Button, Grid, Stack } from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import axios from 'axios';
import * as Yup from 'yup';
import Cookies from 'js-cookie';
import { setAuthCookies, clearAuthCookies } from '../../../utils/api';
import RowadLogo from '../../RowadLogo';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import LoadingButton from "@mui/lab/LoadingButton";

const SignIn = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [LoadingAPI, setLoadingAPI] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const onSubmit = async (values) => {
    setLoadingAPI(true);
    let recaptchaToken = '';
    if (executeRecaptcha) {
      recaptchaToken = await executeRecaptcha('login');
    }
    axios.post(`${process.env.REACT_APP_Back_URL}/userst/authenticate`, {
      "email": values.email,
      "password": values.password,
      "token": recaptchaToken
    }).then((resp) => {
      if(resp.status ===200){
        if(resp.data.icon ==='success'){
        setAuthCookies(resp.data.accessToken, resp.data.refreshToken, resp.data.userId)
        Swal.fire({
          icon: resp.data.icon,
          title: resp.data.message,
          showConfirmButton: false,
          timer: 1500
        }).then(()=>setTimeout( ()=>{navigate('/')},200) )
        }
        else{

          Swal.fire({
            icon: resp.data.icon,
            title: resp.data.message,
        
          })
          setLoadingAPI(false)

        }
  
      
 
      }
    });
  };

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required("Password is Required"),
      // .matches(/^(?=.*[0-9])(?=.*[a-zA-Z]{3,})[a-zA-Z0-9_]+$/, 'Only English letters, at least 4 letters, and at least 1 number.')
      // .min(5, "Too Short")
      // .max(20, "Too Long"),
    email: Yup.string().required('Email is Required').matches(
      /^[a-zA-Z0-9._%+-]+@(rowad-rme|rme-fitout|rme-g|driller-eg|rowad-rme\.net|g-buildings|rowad-investment|tetraes|orascom)\.(com|net)$/,
      "Invalid Email must be from an authorized domain"
    )
  });

  const initialValues = {
    email: "",
    password: "",
    RememberMe: false,
  };
  useEffect(() => {
   navigate('/sign-in')
    if (isValidGUID(id) && id) {
      axios.patch(`${process.env.REACT_APP_Back_URL}/userst/status`, {
        "statecode": 0,
        "statuscode": 1,
        id
      }).then(resp => {
        if (resp.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Account Activitated',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            clearAuthCookies();
            setTimeout(() => {
              navigate('/sign-in');
            }, 1500);
          });
        }
      }).catch(error => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message
        });
      });
    }
  }, []);

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema
  });

  function isValidGUID(str) {
    let regex = new RegExp(/^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/);
    if (str == null) {
        return false;
    }
    if (regex.test(str)) {
        return true;
    } else {
        return false;
    }
  }

  return (
    <div className="container">
      <div className="signin-box">
        <RowadLogo />
        <h2>Sign In</h2>
        <form onSubmit={formik.handleSubmit}>
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              id="email"
              name="email"
              {...formik.getFieldProps('email')}
              required
            />
            {formik.errors.email && formik.touched.email ? <div className='error'>{formik.errors.email}</div> : null}
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              {...formik.getFieldProps('password')}
            />
            {formik.errors.password && formik.touched.password ? <div className='error'>{formik.errors.password}</div> : null}
          </div>
 
          <Link
            style={{ paddingBottom: "10px" }}
            // onClick={handleForgotPasswordClick}
            to="/reset-password"
          >
            Forgot Password
          </Link>

          <Stack spacing={2}>
          <LoadingButton variant="contained"
                    loading={LoadingAPI}
                    type="submit"
                    color="success"
                  >
                  Login
                </LoadingButton>
            <hr />
            <Button variant="outlined" onClick={() => navigate("/sign-up")}>
              Create Account
            </Button>
          </Stack>
        </form>
      </div>
    </div>
  );
};

export default SignIn;